export default "__VITE_ASSET__BrK3lEcR__"